import { render, staticRenderFns } from "./BoardFilterNoticeLayout.vue?vue&type=template&id=1f304b82&scoped=true&"
import script from "./BoardFilterNoticeLayout.vue?vue&type=script&lang=js&"
export * from "./BoardFilterNoticeLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f304b82",
  null
  
)

export default component.exports